module.exports = __webpack_public_path__ + "static/media/signin.0d9da582.png";